import { components } from "components/wrappers";

export default {
  install: (app) => {
    components.forEach(({ name, component }) => {
      app.component(name, component);
    });
  },
};
